import { useCallback, useEffect, useState } from "react";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/reducers/index";
import { sessionEnd, showSnackbar } from "../../redux/actions/index";

// MaterialUI
import { Card, Alert, Typography, Box, Container, CssBaseline } from "@mui/material";
import NavTab from "../../layout/NavTab";

// React router
import { useNavigate } from "react-router-dom";

// Fetch
import { fetchPostProtect } from "../../fetchs/post";
import AddUpdateHosting from "../../components/Hostings/AddUpdateHosting";

import { getAll } from "../../fetchs/get";
import addUpdateHostingData from "../../tools/addUpdateHosting";
import { PriceData } from "../../interface/hosting";

interface IFormValues {
  name: string;
  description: string;
  client: string;
  environment: string;
  margin: number;
  retentionTime: number;
  storage: number;
  servers: [string];
  nbIP: number;
}

const AddHosting = () => {
  const [error, setError] = useState<string>("");
  const [prices, setPrices] = useState<PriceData[]>([]);
  const [typeChecked, setTypeChecked] = useState<boolean>(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = useSelector((state: RootState) => state.user.token);
  const author = useSelector((state: RootState) => state.user.username);

  const getPrices = useCallback(() => {
    if (token) {
      getAll(token, "/hosting/ovh", setPrices, () => dispatch(sessionEnd()), setError);
    }
  }, [token, dispatch]);

  useEffect(() => {
    getPrices();
  }, [getPrices]);

  const addHosting = async (useless: string, values: IFormValues) => {
    const body = await addUpdateHostingData(values, prices, undefined, typeChecked, author);

    if (!body) {
      dispatch(showSnackbar("Un serveur NFS ne peut pas avoir 0 Go de stockage !", "error"));
    } else {
      if (token) {
        await fetchPostProtect(token, "/hosting/add", body)
          .then((response) => {
            if (response.status === 200) {
              setError("");
              response.json().then((result) => {
                navigate(`/hebergement/${result._id}`, { state: "hostingSuccess" });
              });
            } else if (response.status === 401) {
              dispatch(sessionEnd());
            } else {
              response.json().then((result) => setError(result.message));
            }
          })
          .catch((err) => setError(err));
      }
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f8fafc" }}>
      <CssBaseline />
      
      {/* HEADER AVEC BOUTON RETOUR (Même logique que AddProject) */}
      <NavTab 
        text="Ajouter un hébergement" 
        displayReturn={true} 
        hosting={true} // Assure-toi que NavTab gère cette prop pour renvoyer vers /hebergements/
      />

      <Container maxWidth="md" sx={{ mt: 4, pb: 8 }}>
        <Card
          elevation={0}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: "24px",
            border: "1px solid #e2e8f0",
            bgcolor: "white",
            boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.05)"
          }}
        >
          <Box sx={{ mb: 4, textAlign: "center" }}>
            <Typography variant="h6" sx={{ fontWeight: 800, color: "#1e293b", mb: 1 }}>
              Nouvel Hébergement
            </Typography>
            <Typography variant="body2" sx={{ color: "#64748b" }}>
              Merci de renseigner les champs ci-dessous pour l'ajout d'un nouvel hébergement.
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 3, borderRadius: "12px" }}>
              {error}
            </Alert>
          )}

          <Box sx={{ width: "100%" }}>
            <AddUpdateHosting 
              handleSubmit={addHosting} 
              edit={false} 
              isSwitched={false} 
              typeChecked={typeChecked}
              setTypeChecked={setTypeChecked}
            />
          </Box>
        </Card>
      </Container>
    </Box>
  );
};

export default AddHosting;